import { AfterViewInit, Directive, ElementRef, Input } from '@angular/core';
import { RefreshService } from '@grid/services';
import { getWidthFromCopy } from '@grid/utils/html-elements';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { filter, tap } from 'rxjs';

@UntilDestroy()
@Directive({
  selector: '[columnDynamicWidth]',
})
export class ColumnDynamicWidthDirective implements AfterViewInit {
  // eslint-disable-next-line @typescript-eslint/naming-convention
  @Input('columnDynamicWidth') context: {
    columnDef: string;
    isEnabled: boolean;
    maxWidth?: number;
    minWidth?: number;
    externalPadding?: number;
  };

  constructor(
    private hostElement: ElementRef,
    private refreshService: RefreshService
  ) {
    this.refreshService.recomputeDynamicWidth$
      .pipe(
        untilDestroyed(this),
        filter((x) => x === this.context.columnDef),
        tap(() => {
          this.recomputeWidth();
        })
      )
      .subscribe();
  }

  //#region Private methods

  private get cellElement(): HTMLElement {
    return this.hostElement.nativeElement as HTMLElement;
  }

  private get labelElement(): HTMLElement {
    return this.cellElement.querySelector<HTMLElement>('span');
  }

  ngAfterViewInit(): void {
    this.recomputeWidth();
  }

  private recomputeWidth(): void {
    if (this.context.isEnabled) {
      const labelWidth = getWidthFromCopy(this.labelElement);
      this.updateWidth(labelWidth + this.getAdditionalPadding());
    }
  }

  // additional padding
  private getAdditionalPadding(): number {
    return -1 * (this.context.externalPadding ?? 0);
  }

  private updateWidth(updatedWidth: number): void {
    if (this.context.maxWidth) {
      updatedWidth = Math.min(this.context.maxWidth, updatedWidth);
    }
    if (this.context.minWidth) {
      updatedWidth = Math.max(this.context.minWidth, updatedWidth);
    }

    this.refreshService.updateWidthForColumn$.next({
      columnDef: this.context.columnDef,
      updatedWidth,
    });
  }

  //#endregion
}
